import React, { FC, useEffect, useState } from 'react'
import { Image } from 'ui/image'
import { PreviewSlide } from 'ui/preview-slider/PreviewSlide'
import { ZoomableContainer } from 'ui/zoomable-container'

export type ImageWithZoomProps = {
  isVisible: boolean
  onTouchClick: () => void
  onIsZoomedChange: (value: boolean) => void
  src: string
  fit: 'cover' | 'contain'
  alt: string
  ratio?: { x: number; y: number }
  onClickOutside: () => void
}

export const ImageWithZoom: FC<ImageWithZoomProps> = ({
  isVisible,
  onTouchClick,
  onIsZoomedChange,
  src,
  fit,
  alt,
  ratio = { x: 16, y: 9 },
  onClickOutside
}) => {
  const [naturalHeight, setNaturalHeight] = useState<null | number>(null)
  const [naturalWidth, setNaturalWidth] = useState<null | number>(null)
  const [width, setWidth] = useState<null | number>(null)

  return (
    <PreviewSlide
      onClickOutside={onClickOutside}
      onSetWidth={setWidth}
      naturalHeight={naturalHeight}
      naturalWidth={naturalWidth}
      ratio={ratio}
    >
      <ZoomableContainer
        isVisible={isVisible}
        onTouchClick={onTouchClick}
        onIsZoomedChange={onIsZoomedChange}
        naturalHeight={naturalHeight}
        naturalWidth={naturalWidth}
        width={width}
      >
        <Image
          src={src}
          alt={alt}
          fit={fit}
          setNaturalHeight={setNaturalHeight}
          setNaturalWidth={setNaturalWidth}
          ratio={ratio}
        />
      </ZoomableContainer>
    </PreviewSlide>
  )
}
